import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlIndicador = '/service/contabilidade/dotacao/'

class IndicadorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getIndicador() {
        return this.conex.get(urlIndicador + 'indicador/')
    }
}

export default IndicadorService
